<template>
  <div id="contents">
    <div class="recruit_young" v-if="young_post" >
      <div class="recruit_young_main" :class="['young_' + young_post.id]">
        <div class="title_area">
          <p class="title_area_title" v-for="title in young_post.title" :key="title.id">{{ title.text }}</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <p class="title_area_caption">{{ young_post.caption }}</p>

        <div class="producer" v-for="producer in young_post.producer" :key="producer.id">
          <div class="thumbnail">
            <img :src="producer.image" alt="">
          </div>
          <div class="text_area">
            <p class="info">{{ producer.info }}</p>
            <h4>{{ producer.name }}</h4><p class="name_en">{{ producer.name_en }}</p>
            <p class="text" v-html="producer.text"></p>
          </div>
        </div>
        <div class="journals_main">
          <div class="journal" v-for="(journal, index) in young_post.journals" :key="journal.id" :id="'journal_section' + index">

            <div class="even_journal" :id="journal.anchor_link">
              <div class="image_area">
                <div class="image_layout_1_box" v-if="journal.image_layout_type === 1">
                  <img class="image_layout" v-for="images in journal.images" :key="images.id" :src="images.image" alt="">
                  <p class="caption" v-html="journal.caption"></p>
                </div>
                <div class="image_layout_2_box" v-if="journal.image_layout_type === 2">
                  <img class="image_layout" :src="journal.image" alt="">
                  <p class="caption" v-html="journal.caption"></p>
                </div>
              </div>
              <div class="text_aera" :class="['young_' + young_post.id + '_' + journal.id]">
                <p class="title" v-for="title in journal.title" :key="title.id" :class="[journal.id == 4 && request_id == 1 ? 'padding_right0' : '' ]" v-html="title.text"></p>
                <p class="date">{{ journal.date }}</p>
                <p class="text" v-html="journal.text"></p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="relation_young_list">
        <div class="title_area">
          <p class="title">他の先輩社員たちの</p>
          <p class="title">記事を見る</p>
        </div>
        <slick ref="slick" :options="slick_options" id="relation_movie_slider" v-if="young_post">
          <li v-for="relation_young in young_post.relation_post" :key="relation_young.id" @click="reload_model(relation_young.wakate_id, 'young')">
            <div class="thumbnail">
              <img :src="relation_young.thumbnail" alt="">
            </div>
            <div class="young_titel">
              <p class="young_title_text" v-for="title in relation_young.title" :key="title.id">{{ title.text }}</p>
            </div>
          </li>
        </slick>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
import young_post_list from './js/recruit_young.json'
import Slick from 'vue-slick';
export default {
  name: 'recruit_young',
  data() {
    return {
      young_post_list: young_post_list,
      young_post: null,
      request_id: this.$route.params.id,
      loading: false,
      post_list: null,
      error: null,
      anchor_link_timeout: false,
      slick_options: {
        autoplay:true,
        autoplaySpeed:5000,
        dots:true,
      }
    }
  },
  props: [
    'post_type',
    'link'
  ],
  components: {
    Slick
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    this.fetch_young_post(this.$route.params.id)

    //animation
    this.$nextTick(() => {
      var secTopArr = new Array();
      var current = -1;
      $('.journal').each(function (i) {
        secTopArr[i] = $(this).offset().top;
      });
      $(window).scroll(function () {
        for (var i = secTopArr.length-1; i>=0; i--) {
          if ($(window).scrollTop() > secTopArr[i] - 250) {
            if (i != current) {
              $('#journal_section'+i).addClass('move_view');
              current = i;
              break;
            }
          }
        }
      });
    });

  },
  methods: {
    fetch_young_post(request_id){
      this.young_post = this.young_post_list[request_id]
      if (this.post_type != 'all'){
        setTimeout(() => {
          if (this.link){
            var speed = 1500;
            var href = this.link
            var target = $('#' + href)
            var position = target.offset().top - 50;
            $('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
          }
        }, 300);
      }
      setTimeout(() => {
        this.add_css_to_slider()
      }, 200);
    },
    reload_model(post_id, layout) {
      var post = this.young_post_list.find(post => post.id == post_id);
      if (post != null){
        this.$emit('reload_model', post_id, layout);
      }
    },
    close(){
      this.$emit('close_icon');
    },
     add_css_to_slider(){
      $("#relation_movie_slider").addClass('slider');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw

  .recruit_young
    &_main
      width: 90.4vw
      margin: calc(36.1vw - 41px) auto 0
      padding: 90px 0 40px 0
      background-color: #fff
      position: relative
      &.young_10
        .journals_main
          .journal
            .even_journal
              .text_aera
                .title
                  padding: 0 5px 2px 5px
                  line-height: 39px
              .image_area
                .image_layout_2_box
                  .caption
                    letter-spacing: .066em
      .title_area
        position: absolute
        top: -25px
        left: 21px
        &_title
          @include recruit_font(26px, 42px, 0.176em)
          color: #fff
          background: #8B53AF
          padding-left: 9px
          display: table
        &_caption
          @include recruit_font(12px, 23px, .14em)
          margin: 0 auto
          width: 297px
      .back_btn_icon
        position: absolute
        top: -78px
        left: 0vw
        img
          width: 32px
          height: 32px
      .producer
        width: 79.2vw
        margin: 0 auto
        margin-top: 35px
        .thumbnail
          width: 144px
          height: 144px
          img
            width: 144px
            height: 144px
        .text_area
          .info
            @include recruit_font(16px, 28px, 1.5px)
            color: #FF7689
            margin-top: 26px
          h4
            @include recruit_font(31px, 28px, 0.196em)
            color: #FF7689
            margin-top: 10px
          .name_en
            @include recruit_font(17px, 17px, 1px)
            color: #FF7689
            margin-top: 10px
            display: inline-block
          .text
            @include recruit_font(12px, 23px, 0.1em)
            margin-top: 17px
      .journals_main
        .journal
          margin-top: 35px

          .image_area
            position: relative
            overflow: hidden
            opacity: 0
            &::before
              content: ""
              display: block
              position: absolute
              background: #8B53AF
              top: 0
              left: -10%
              width: 150%
              height: 120%
              z-index: 50
              -webkit-transform: skewX(10deg)
              transform: skewX(10deg)

          .text_aera
            .title
              position: relative
              overflow: hidden
              opacity: 0
              &::before
                content: ""
                display: block
                position: absolute
                background: #fff
                top: 0
                left: -10%
                width: 150%
                height: 120%
                z-index: 50
                -webkit-transform: skewX(10deg)
                transform: skewX(10deg)

            .text,.date
              opacity: 0
              position: relative

          .even_journal
            .image_area
              width: 295px
              margin: 0 auto
              img
                width: 295px
                height: auto
              .image_layout_1_box
                .image_layout:not(:first-child)
                  margin-top: 19px
                .caption
                  @include recruit_font(12px, 28px, 0.066em)
                  color: #8B53AF
                  display: block
                .caption
                  .indention
                    height: 20px
                    &:not(:first-child)
                      margin-bottom: 8px
              .image_layout_2_box
                .image_layout
                  width: 295px
                  height: 295px
                .caption
                  @include recruit_font(12px, 28px, 0.026em)
                  color: #8B53AF
                  display: block
                .caption
                  .indention
                    height: 20px
                    &:not(:first-child)
                      margin-bottom: 8px
            .text_aera
              width: 79.2vw
              margin: 22px auto 0
              &.young
                &_10
                  &_0,&_1,&_3
                    .title
                      letter-spacing: -0.015em
                  &_2,&_4,&_5
                    .title
                      letter-spacing: 0.136em
              .title
                @include recruit_font(29px, 46px, 2px)
                color: #fff
                background: #8B53AF
                display: table
                padding: 0 5px 0 5px
                &:not(:first-child)
                  margin-top: 5px
              .title.padding_right0
                letter-spacing: 0px
                padding: 0 0px 0 5px
              .date
                @include recruit_font(20px, 28px, 0.136em)
                color: #8B53AF
                margin-top: 12px
              .text
                @include recruit_font(12px, 23px, 0.14em)
                margin-top: 24px
        //以下,animation
        .move_view
          //image
          .image_area
            opacity: 1

            &::before
              -webkit-animation: fadein1 1.2s 1 ease forwards
              animation: fadein1 1.2s 1 ease forwards

          @keyframes fadein1
            0%
              width: 150%
              left: -12.5%
              opacity: 1
            60%
              width: 150%
              left: 150%
              opacity: 1
            100%
              width: 150%
              left: 150%
              opacity: 0
          .text_aera
            .title
              opacity: 1
              &::before
                -webkit-animation: titilein1 1.8s 1 ease forwards
                animation: titilein1 1.8s 1 ease forwards

            @keyframes titilein1
              0%
                width: 150%
                left: -12.5%
                opacity: 1
              60%
                width: 150%
                left: 150%
                opacity: 1
              100%
                width: 150%
                left: 150%
                opacity: 0

            .text,.date
              -webkit-animation: textin0 1.5s cubic-bezier(0.075, 0.82, 0.165, 1) 1 forwards 0.8s
              animation: textin0 1.5s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.8s

              @keyframes textin0
                0%
                  opacity: 0
                  top: 60px
                30%
                  opacity: 1
                100%
                  opacity: 1
                  top: 0px

    .relation_young_list
      width: 90.4vw
      margin: 62px auto 0
      padding-bottom: 112px
      .title_area
        .title
          @include recruit_font(21px, 41px, 0.176em)
          background-color: #fff
          color: #FF7689
          padding: 0 10px 0 11px
          display: inline-block
          &:not(:first-child)
            margin-top: 4px
      ul
        margin-top: 23px
        margin-bottom: 51px
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        li
          width: 318px
          margin-bottom: 59px
          .thumbnail
            width: 318px
            height: 180px
            position: relative
            img
          p
            @include recruit_font(12px, 12px, 1px)
            color: #fff
            margin-top: 9px
      .slider
        margin-top: 23px
        margin-bottom: 0px
  @media screen and (max-width: 374px)
    .recruit_young
      &_main
        margin: 86px auto 0
        .title_area
          top: -6.7vw
          left: 5.6vw
          &_title
            @include recruit_font(26px, 42px, 2px)
            &:not(:first-child)
              padding-right: 5px
          &_caption
            @include recruit_font(14px, 28px, 1.5px)
            width: 78.7vw
        .back_btn_icon
          top: -78px
          left: 0vw
        .producer
          .text_area
            .info
              @include recruit_font(16px, 28px, 0.054em)
            .text
              @include recruit_font(12px, 23px, 0.14em)
        .journals_main
          .journal
            .image_area
              &::after
              &::before
            .text_aera
              .title
                &::after
                &::before
              .text,.date
            .even_journal
              .image_area
                width: 78.7vw
                img
                .image_layout_1_box
                  .image_layout:not(:first-child)
                  .caption
                .image_layout_2_box
                  margin: 0 auto
                  width: 78.7vw
                  .image_layout
                    width: 78.7vw
                    height: 78.7vw
                  .caption
                    text-align: start
                    margin-top: 4px
                    line-height: 20px
              .text_aera
                .title
                  font-size: 24px
                  &:not(:first-child)
                .date
                .text
</style>

<style>
  .image_layout_1_box .caption .indention
  {
    height: 20px;
  }
  .image_layout_1_box .caption .indention:not(:first-child)
  {
    margin-bottom: 8px;
  }
  .image_layout_2_box .caption .indention
  {
    height: 20px;
  }
  .image_layout_2_box .caption .indention:not(:first-child)
  {
    margin-bottom: 8px;
  }
  .slider
  {
    margin-top: 23px !important;
    margin-bottom: 0px !important;
  }
  .slider .slick-prev
  {
    left: 21.5vw !important;
    bottom: -50px !important;
    top: unset !important;
  }
  .slider .slick-prev:before
  {
    background-image: url('../assets/img/common/recruit_2021/prev_arrow.svg') !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    font-family: none !important;
    color: unset !important;
    opacity: 1 !important;
    font-size: 17px !important;
  }
  .slider .slick-next
  {
    right: 19.5vw !important;
    bottom: -50px !important;
    top: unset !important;
  }
  .slider .slick-next:before
  {
    background-image: url('../assets/img/common/recruit_2021/next_arrow.svg') !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    font-family: none !important;
    color: unset !important;
    opacity: 1 !important;
    font-size: 17px !important;
  }
  .slider .slick-dots
  {
    width: 41% !important;
    margin: 0 calc(59% / 2) !important;
    line-height: 10px !important;
    bottom: -44px !important;
    display: flex !important;
    justify-content: space-around !important;
  }
  .slider .slick-dots .slick-active button:before
  {
    color: #FFBA00 !important;
    opacity: 1 !important;
    width: 100% !important;
  }
  .slider .slick-dots li
  {
    width: 23px !important;
    height: 23px !important;
    margin: 0 !important;
  }
  .slider .slick-dots li button:before
  {
    color: #FFF !important;
    opacity: 1 !important;
  }
  .slider li .thumbnail
  {
    width: 90.4vw !important;
    height: 50.9vw !important;
    overflow: hidden !important;
  }
  .slider li .thumbnail img
  {
    width: 101% !important;
  }
  .slider li .young_titel{
    margin-top: 3px;
  }
  .slider li .young_title_text
  {
    margin-top: 7px;
    font-family: 'Noto Sans JP', sans-serif !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    list-style: 31px !important;
    letter-spacing: 0.176em !important;
    color: #fff !important;
    text-align: center !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/recruit_young.vue